import { actions } from 'src/constants';

const initialState = {
  data: [],
  hasLoaded: false,
  isLoading: false,
};

const actionMap = {
  [actions.ACTIVITY_GROUPS_GET_REQUEST]: (state) => ({
    ...state,
    hasLoaded: false,
    isLoading: true,
  }),

  [actions.ACTIVITY_GROUPS_GET_SUCCESS]: (state, { result }) => ({
    ...state,
    data: result.data,
    hasLoaded: true,
    isLoading: false,
  }),

  [actions.ACTIVITY_GROUPS_GET_FAILURE]: (state) => ({
    ...state,
    hasLoaded: false,
    isLoading: false,
  }),

  [actions.ACTIVITY_GROUPS_RESET]: () => initialState,
};

export default (state = initialState, action) => {
  if (actionMap[action.type]) {
    return actionMap[action.type](state, action);
  }

  return state;
};
